import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class AdministrationGroupAction extends BaseAction {
    public getAllSearchableGroups(): void {
        this.Execute(ServerOperations.Server.Myle_AdministrationGetEmployeeGroups);
    }

    public GetGroupInfo(groupId: string): void {
        var requestData = {
            EmployeeGroupId: groupId
        };
        this.Execute(ServerOperations.Server.Myle_Admin_LoadGroupSetting, requestData);
    }

    public upsertGroup(group: EmployeeGroup, isApplyForUsers?: boolean): void {
        var requestData = {
            EmployeeGroup: group,
            IsApplyForUsers: isApplyForUsers
        };
        this.Execute(ServerOperations.Server.Myle_Admin_UpsertGroupSetting, requestData);
    }

    public deleteClickableTextSection(groupId: string, context: string, lang: string): void {
        var requestData = {
            EmployeeGroupId: groupId,
            Context: context,
            IsGroupMode: true,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Employee_DeleteClickableTextSection, requestData);
    }

    public getTabDetailsFromSpecificGroup(context: string, groupId: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang,
            EmployeeGroupId: groupId
        };
        this.Execute(ServerOperations.Server.GetClickableTextDetailsSpecificUserSpecificTab, request);
    }

    public getAllClickableTextCategories(context: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang

        };
        this.Execute(ServerOperations.Server.Employee_GetClickableTextCategories, request);
    }

    public getClickableTextDetails(tab: string, context: string, lang: string): void {
        var request = {
            TabName: tab,
            Context: context,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Employee_getClickableTextDetails, request);
    }

    public getAllGroupsWithClickableText(context: string, lang: string): void {
        var request = {
            Context: context,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.GetAllGroupsWithClickableText, request);
    }

    public importListOfClickableText(textList: ClickableTextItem[], emoloyeeGroupId: string, context: string, tabs: string[], lang: string): void {
        var request = {
            TextList: textList,
            EmployeeGroupId: emoloyeeGroupId,
            Context: context,
            TabsName: tabs,
            IsGroupMode: true,
            LanguageCode: lang
        };
        this.Execute(ServerOperations.Server.Import_ClickableText_List, request);
    }

    public getAllCliackableText(id: string, isImportDeleteTexts?: boolean): void {
        var request = {
            EmployeeGroupId: id,
            IsFromGroup: true,
            IsImportDeleteTexts: isImportDeleteTexts

        };
        this.Execute(ServerOperations.Server.GetClickableTextSpecificUser, request);
    }

    public getCliackableTextSpecificUser(id: string): void {
        var request = {
            EmployeeId: id
        };
        this.Execute(ServerOperations.Server.GetClickableTextSpecificUser, request);
    }

    public createListOfClickableText(textList: ClickableTextItem[], groupId: string): void {
        var request = {
            TextList: textList,
            EmployeeGroupId: groupId,
            IsGroupMode: true
        };
        this.Execute(ServerOperations.Server.Create_List_ClickableText, request);
    }

    public updateGroupName(employeeGroupId: string, newName: string): void {
        var request = {
            EmployeeGroupId: employeeGroupId,
            NewGroupName: newName
        };
        this.Execute(ServerOperations.Server.Myle_Admin_RenameGroup, request);
    }
}

export { AdministrationGroupAction };
